'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 23 21', width: '100%', height: '100%' },
          _react2.default.createElement(
            'g',
            { stroke: color, strokeWidth: '1.5', fill: 'none', fillRule: 'evenodd' },
            _react2.default.createElement('path', { d: 'M13.85 11.386h4.527m-4.527 3.42h3.307', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            _react2.default.createElement('path', { d: 'M9.352 12.66a2.254 2.254 0 1 1-2.256-2.253 2.254 2.254 0 0 1 2.252 2.253z' }),
            _react2.default.createElement('path', { d: 'M11.35 19.856a4.781 4.781 0 0 0-8.5 0', strokeLinecap: 'round' }),
            _react2.default.createElement('path', { d: 'M13.3 8.184H9.466c-.74 0-1.34-.6-1.34-1.34V3.012c0-.74.6-1.34 1.34-1.34H13.3c.74 0 1.34.6 1.34 1.34v3.832c0 .74-.6 1.34-1.34 1.34z', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            _react2.default.createElement('path', { d: 'M8.127 5.928H2.64c-1.044 0-1.89.787-1.89 1.758v10.806c0 .97.847 1.758 1.892 1.758h17.483c1.044 0 1.89-.787 1.89-1.758V7.686c0-.97-.846-1.758-1.89-1.758H14.64', strokeLinecap: 'round', strokeLinejoin: 'round' })
          )
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Group';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Group.js
// module id = 1071
// module chunks = 0